import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Settings.css";
import click from "./assets/sounds/click.mp3";
import { useTranslation } from "react-i18next";

export default function Settings() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = location.state || {};
  const token = location.state?.token || localStorage.getItem('token');

  const [soundEnabled, setSoundEnabled] = useState(true);
  const [timerSoundEnabled, setTimerSoundEnabled] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL;

  const { t, i18n } = useTranslation();

    useEffect(() => {
      if (profile?.preferredLanguage) {
        i18n.changeLanguage(profile.preferredLanguage.toLowerCase());
      }
    }, [profile?.preferredLanguage]);

  const playSound = (sound) => {
    if (soundEnabled) {
      const audio = new Audio(sound);
      audio.play();
    }
  };

  // 🔄 Charger les préférences depuis l’API
  useEffect(() => {
    const fetchPreferences = async () => {
      try {
        console.log("Mon token JWT:", token);
        const res = await fetch(`${API_URL}/api/auth/preferences`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const prefs = await res.json();
          setSoundEnabled(prefs.soundEnabled);
          setTimerSoundEnabled(prefs.timerSoundEnabled);
        }
      } catch (err) {
        console.error("Erreur chargement préférences:", err);
      }
    };
    if (token) fetchPreferences();
  }, [token]);

  // 💾 Sauvegarder les préférences
  const savePreferences = async (newPrefs) => {
    try {
      console.log("Mon token JWT:", token);
      const res = await fetch(`${API_URL}/api/auth/preferences`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newPrefs),
      });
      if (!res.ok) throw new Error(t("errors.profileSave"));
    } catch (err) {
      console.error("Erreur sauvegarde préférences:", err);
    }
  };

  const toggleSoundEnabled = () => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    savePreferences({ soundEnabled: newValue, timerSoundEnabled });
    if (newValue) playSound(click);
  };

  const toggleTimerSoundEnabled = () => {
    const newValue = !timerSoundEnabled;
    console.log("Mon token JWT:", token);
    setTimerSoundEnabled(newValue);
    savePreferences({ soundEnabled, timerSoundEnabled: newValue });
    if (soundEnabled && newValue) playSound(click);
  };

  return (
    <div className="settings-container">
      <h1>{t("settings.title")}</h1>
      <div className="settings-content">
        <h3>{t("settings.soundSection")}</h3>

        <div className="settings-option">
          <label>
            <input
              type="checkbox"
              checked={soundEnabled}
              onChange={toggleSoundEnabled}
            />{t("settings.buttonSounds")}
          </label>
        </div>

        <div className="settings-option">
          <label>
            <input
              type="checkbox"
              checked={timerSoundEnabled}
              onChange={toggleTimerSoundEnabled}
            />{t("settings.timerSounds")}
          </label>
        </div>
      </div>

      {/* 🔑 Bouton changer mot de passe */}
      <button
        className="settings-btn"
        onClick={() => {
          if (soundEnabled) playSound(click);
          navigate("/change-password", { state: { profile, token, lang: i18n.language } });
        }}
      >
        {t("settings.changePassword")}
      </button>
      <p className="settings-warning">
        {t("settings.alcoholWarning")}
      </p>

      <button
        className="back-btn"
        onClick={() => {
          if (soundEnabled) playSound(click);
          navigate(-1);
        }}
      >
        ←
      </button>
      <a
        href="https://odyssait.com/textes-legaux-vinodyssait/"
        className="bottom-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("settings.legacy")}
      </a>
    </div>
  );
}
